import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Country } from "country-state-city";
import FormAction from "./formAction";

function Review(props) {
  const { savedSteps, bayanProgress, selectedProgramLabel } = useSelector(
    (state) => ({
      savedSteps: state.applicationReducer.savedSteps,
      bayanProgress: state.applicationReducer.bayanProgress,
      selectedProgramLabel: state.applicationReducer.selectedProgramLabel,
    }),
    shallowEqual
  );
  const programSelection = savedSteps.loggedOutUserInfo;
  const applicantInfoStep = savedSteps.applicantInfo;
  const contactInfoStep = savedSteps.contactInfo;
  const residencyStep = savedSteps.residency;
  const demographicsStep = savedSteps.demographics;
  const academicInfoStep = savedSteps.academicInfo;
  const educationalHistoryStep = savedSteps.educationalHistory;
  const toeflScoreStep = savedSteps.toeflScore;
  const applicationEssayStep = savedSteps.applicationEssay;
  const transcriptsStep = savedSteps.transcripts;
  const referencesStep = savedSteps.references;
  const applicationFeeStep = savedSteps.applicationFee;

  const getCountry = (countryCode) => {
    Country.getCountryByCode(countryCode);
    return Country.getCountryByCode(countryCode) &&
      Country.getCountryByCode(countryCode).name
      ? Country.getCountryByCode(countryCode).name
      : "---";
  };

  const getGenderDescription = () => {
    if (demographicsStep.gender_id == 1) {
      return "Male";
    } else if (demographicsStep.gender_id == 2) {
      return "Female";
    } else if (demographicsStep.gender_id == 3) {
      return "Decline to State";
    }
  };

  const getPriorEducation = (key) => {
    if (key == 1) {
      return "Some College";
    } else if (key == 2) {
      return `Bachelor's Degree`;
    } else if (key == 3) {
      return `Master's College`;
    } else if (key == 4) {
      return `Doctoral's College`;
    }
  };

  const getProgram = (key) => {
    switch (key) {
      case 38:
        return "M.A. in Islamic Studies (48 units)";
      case 39:
        return "M.A. in Islamic Leadership (48 units)";
      case 40:
        return "M.A. in Islamic Education (48 units)";
      case 41:
        return "M.A. in Islamic Theology (48 units)";
      case 42:
        return "MDiv in Islamic Chaplaincy (75 units)";
      case 43:
        return "Chaplaincy Certificates";
      case 48:
        return "DMin in Islamic Leadership";
      default:
        return "Not Selected";
    }
  };
  return (
    <>
      <div className="app-form-container begin-screen card">
        <div className="main-heading bayan-main-heading">
          <img src="/icons/empty-network.png" />
          Chicago Theological Seminary
          <br />
          BAYAN - Bayan Islamic Graduate School.
        </div>
        <h5>{selectedProgramLabel || ""}</h5>
        <div className="body-content">
          {programSelection && Object.keys(programSelection).length > 0 && (
            <div className="block">
              <p>
                <strong>Program Selection</strong>
              </p>
              <table width="100%">
                <tbody>
                  <tr>
                    <td>Email</td>
                    <td>{programSelection.email}</td>
                  </tr>
                  <tr>
                    <td>Program</td>
                    <td>{getProgram(programSelection.program_id)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          {applicantInfoStep && Object.keys(applicantInfoStep).length > 0 && (
            <div className="block">
              <p>
                <strong>Applicant Information</strong>
              </p>
              <table width="100%">
                <tbody>
                  <tr>
                    <td>First Name</td>
                    <td>{applicantInfoStep.first_name}</td>
                  </tr>
                  <tr>
                    <td>Preferred Name</td>
                    <td>{applicantInfoStep.preferred_name}</td>
                  </tr>
                  <tr>
                    <td>Middle Name</td>
                    <td>{applicantInfoStep.middle_name}</td>
                  </tr>
                  <tr>
                    <td>Last Name</td>
                    <td>{applicantInfoStep.last_name}</td>
                  </tr>
                  {/* <tr>
                <td>Maiden Name</td>
                <td>{applicantInfoStep.maiden_name}</td>
              </tr> */}
                  <tr>
                    <td>Date of birth</td>
                    <td>
                      {applicantInfoStep.month}/{applicantInfoStep.date}/
                      {applicantInfoStep.year}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
          {contactInfoStep && Object.keys(contactInfoStep).length > 0 && (
            <div className="block">
              <p>
                <strong>Contact Information</strong>
              </p>
              <table width="100%">
                <tbody>
                  <tr>
                    <td>Current Mailing Address, Line 1</td>
                    <td>{contactInfoStep.mailing_address_1}</td>
                  </tr>
                  <tr>
                    <td>Current Mailing Address, Line 2</td>
                    <td>{contactInfoStep.mailing_address_2}</td>
                  </tr>
                  <tr>
                    <td>City</td>
                    <td>{contactInfoStep.city}</td>
                  </tr>
                  <tr>
                    <td>Country</td>
                    <td>{getCountry(contactInfoStep.country)}</td>
                  </tr>
                  <tr>
                    <td>State</td>
                    <td>{contactInfoStep.state}</td>
                  </tr>
                  <tr>
                    <td>Zipcode</td>
                    <td>{contactInfoStep.zip_code}</td>
                  </tr>
                  <tr>
                    <td>Primary Phone No</td>
                    <td>{contactInfoStep.primary_phone_no}</td>
                  </tr>
                  <tr>
                    <td>Alternate Phone No</td>
                    <td>{contactInfoStep.alternate_phone_no}</td>
                  </tr>
                  <tr>
                    <td>Contact Preference </td>
                    <td>{contactInfoStep.preference_of_contact}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          {residencyStep && Object.keys(residencyStep).length > 0 && (
            <div className="block">
              <p>
                <strong>Residency</strong>
              </p>
              <table width="100%">
                <tbody>
                  <tr>
                    <td>International Applicant</td>
                    <td>
                      {residencyStep.is_international_applicant == 1
                        ? "Yes"
                        : "No"}
                    </td>
                  </tr>
                  <tr>
                    <td>English a second language</td>
                    <td>
                      {residencyStep.is_english_second == 1 ? "Yes" : "No"}
                    </td>
                  </tr>
                  <tr>
                    <td>US citizen</td>
                    <td>{residencyStep.is_citizen == 1 ? "Yes" : "No"}</td>
                  </tr>
                  <tr>
                    <td>Country of residence</td>
                    <td>{getCountry(residencyStep.country_of_residence)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          {demographicsStep && Object.keys(demographicsStep).length > 0 && (
            <div className="block">
              <p>
                <strong>Demographics</strong>
              </p>
              <table width="100%">
                <tbody>
                  <tr>
                    <td>Gender</td>
                    <td>{getGenderDescription()}</td>
                  </tr>
                  <tr>
                    <td>Race/Ethnicity</td>
                    <td>
                      {demographicsStep?.race_ethnicity
                        ?.toString()
                        ?.split(",")
                        .map((src, i) => {
                          if (src == 1) {
                            switch (i) {
                              case 0:
                                return "White/Non-hispanic";
                              case 1:
                                return "Hispanic/Latinx/Spanish Origin";
                              case 2:
                                return "Black/African American";
                              case 3:
                                return "Asian/Pacific Islander";
                              case 4:
                                return "Middle Eastern/North African Descent";
                              case 5:
                                return "Native American/Alaskan";
                              case 6:
                                return "Non-Resident Alien";
                              case 7:
                                return "Undisclosed";
                              case 8:
                                return "Other";
                            }
                          }
                          return "";
                        })
                        .filter((src) => !!src)
                        .join()}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          {academicInfoStep && Object.keys(academicInfoStep).length > 0 && (
            <div className="block">
              <p>
                <strong>Academic Information</strong>
              </p>
              <table width="100%">
                <tbody>
                  <tr>
                    <td>Enrollment Date</td>
                    <td>
                      {academicInfoStep.intended_enrollment_date == 1
                        ? "Spring 2022"
                        : academicInfoStep.intended_enrollment_date == 2
                        ? "Fall 2021"
                        : academicInfoStep.intended_enrollment_date ?? ""}
                    </td>
                  </tr>
                  {
                    // <tr>
                    //<td>Study Intention</td>
                    //<td>{academicInfoStep.intended_term == 1 ? 'Online' : ''}</td>
                    //<td>{academicInfoStep.intended_term == 2 ? 'Face-to-Face' : ''}</td>
                    //{/* <td>{academicInfoStep.intended_term == 3 ? 'Hybrid' : ''}</td> */}
                    //</tr>
                  }
                  <tr>
                    <td>How did you learn about Bayan?</td>
                    <td>
                      {academicInfoStep?.leading_source
                        ?.toString()
                        ?.split(",")
                        .map((src, i) => {
                          if (src == 1) {
                            switch (i) {
                              case 0:
                                return "Social Media";
                              case 1:
                                return "Graduate School Fair";
                              case 2:
                                return "Conference";
                              case 3:
                                return "Religious Affiliation";
                              case 4:
                                return "Bayan Event";
                              case 5:
                                return "Bayan Faculty/Staff/Alum";
                              case 6:
                                return "Current Bayan Student";
                              case 7:
                                return "Online Advertisement";
                              case 8:
                                return "Internet Search";
                            }
                          }
                          return "";
                        })
                        .filter((src) => !!src)
                        .join()}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          {educationalHistoryStep &&
            Object.keys(educationalHistoryStep).length > 0 && (
              <div className="block">
                <p>
                  <strong>Educational History</strong>
                </p>
                <table width="100%">
                  <tbody>
                    <tr>
                      <td>Prior Education</td>
                      <td>
                        {getPriorEducation(
                          educationalHistoryStep.prior_education
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Education History</td>
                      <td>{educationalHistoryStep.educational_history}</td>
                    </tr>
                    <tr>
                      <td>Uploaded Resume</td>
                      <td>
                        {educationalHistoryStep.educational_resume != null
                          ? "Resume is uploaded"
                          : ""}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}

          {toeflScoreStep && Object.keys(toeflScoreStep).length > 0 && (
            <div className="block">
              <p>
                <strong>Toefl Score</strong>
              </p>
              <table width="100%">
                <tbody>
                  <tr>
                    <td>Completed TOEFL Submission</td>
                    <td>
                      {toeflScoreStep.completed_submitted_toefl == 1
                        ? "Yes"
                        : "No"}
                    </td>
                  </tr>
                  <tr>
                    <td>Date of TOEFL</td>
                    <td>
                      {toeflScoreStep.month_of_toefl}/
                      {toeflScoreStep.date_of_toefl}/
                      {toeflScoreStep.year_of_toefl}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          {transcriptsStep && Object.keys(transcriptsStep).length > 0 && (
            <div className="block">
              <p>
                <strong>Transcripts</strong>
              </p>
              <table width="100%">
                <tbody>
                  <tr>
                    <td>Transcripts Submitted</td>
                    <td>
                      {transcriptsStep.submit_transcripts == 1 ? "Yes" : "No"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          {referencesStep && Object.keys(referencesStep).length > 0 && (
            <div className="block">
              <p>
                <strong>References</strong>
              </p>
              <table width="100%">
                <tbody>
                  <tr>
                    <td>Waived Rights</td>
                    <td>{referencesStep.waive_rights == 1 ? "Yes" : "No"}</td>
                  </tr>
                  <tr>
                    <td>First Academic Reference Name</td>
                    <td>{referencesStep.first_academic_reference_name}</td>
                  </tr>
                  <tr>
                    <td>First Academic Reference Email</td>
                    <td>{referencesStep.first_academic_reference_email}</td>
                  </tr>
                  <tr>
                    <td>First Academic Reference Note</td>
                    <td>{referencesStep.first_academic_reference_note}</td>
                  </tr>
                  <tr>
                    <td>Second Academic Reference Name</td>
                    <td>{referencesStep.second_academic_reference_name}</td>
                  </tr>
                  <tr>
                    <td>Second Academic Reference Email</td>
                    <td>{referencesStep.second_academic_reference_email}</td>
                  </tr>
                  <tr>
                    <td>Second Academic Reference Note</td>
                    <td>{referencesStep.second_academic_reference_note}</td>
                  </tr>
                  <tr>
                    <td>First Bayan Reference Name</td>
                    <td>{referencesStep.first_bayan_reference_name}</td>
                  </tr>
                  <tr>
                    <td>First Bayan Reference Email</td>
                    <td>{referencesStep.first_bayan_reference_email}</td>
                  </tr>
                  <tr>
                    <td>First Bayan Reference Note</td>
                    <td>{referencesStep.first_bayan_reference_note}</td>
                  </tr>
                  <tr>
                    <td>Second Bayan Reference Name</td>
                    <td>{referencesStep.second_bayan_reference_name}</td>
                  </tr>
                  <tr>
                    <td>Second Bayan Reference Email</td>
                    <td>{referencesStep.second_bayan_reference_email}</td>
                  </tr>
                  <tr>
                    <td>Second Bayan Reference Note</td>
                    <td>{referencesStep.second_bayan_reference_note}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          {applicationEssayStep &&
            Object.keys(applicationEssayStep).length > 0 && (
              <div className="block">
                <p>
                  <strong>Application Essay</strong>
                </p>
                <table width="100%">
                  <tbody>
                    {programSelection.program_id !== 48 && (
                      <tr>
                        <td>Application Essay</td>
                        <td>{applicationEssayStep.essay ? "Yes" : "No"}</td>
                      </tr>
                    )}
                    {programSelection.program_id !== 48 &&
                      programSelection.program_id !== 42 &&
                      programSelection.program_id !== 43 && (
                        <tr>
                          <td>Statement of Focus</td>
                          <td>
                            {applicationEssayStep.statementOfFocus
                              ? "Yes"
                              : "No"}
                          </td>
                        </tr>
                      )}
                    {programSelection.program_id === 48 && (
                      <>
                        <tr>
                          <td>Doctor of Ministry Essay</td>
                          <td>
                            {applicationEssayStep.doctorMinistryEssay
                              ? "Yes"
                              : "No"}
                          </td>
                        </tr>
                        <tr>
                          <td>Sample Ministry Paper</td>
                          <td>
                            {applicationEssayStep.sampleMinistryPaper
                              ? "Yes"
                              : "No"}
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            )}

          {applicationFeeStep && Object.keys(applicationFeeStep).length > 0 && (
            <div className="block">
              <p>
                <strong>Application Fee</strong>
              </p>
              <table width="100%">
                <tbody>
                  <tr>
                    <td>Fee Paid</td>
                    <td>
                      {applicationFeeStep.is_fee_paid == 1 ? "Yes" : "No"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
      {props.fromLanding && (
        <div
          className="login-btn yellow-btn cursor-pointer"
          onClick={props.closeReview}
        >
          Close
        </div>
      )}
    </>
  );
}

export default Review;
